<template>
  <div class="about">
    <div class="about-header">
      <div class="header-content">
        <div class="logo-section">
          <div class="app-logo">
          <img src="/images/logo.png" alt="DMS Logo" class="logo-image">
        </div>
          <div class="app-info">
            <h1>DMS</h1>
            <p class="app-tagline">Automatisation intelligente du traitement des emails commerciaux</p>
            <div class="version-info">
              <span class="version-badge">Version 1.0.0</span>
              <span class="build-info">Build 2024.01</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="about-content">
      <!-- Description -->
      <section class="info-section">
        <div class="section-header">
          <i class="fas fa-info-circle"></i>
          <h2>À propos de DMS</h2>
        </div>
        <div class="section-content">
          <p>
            DMS est une solution d'automatisation intelligente conçue pour révolutionner 
            le traitement des emails commerciaux. Notre plateforme utilise l'intelligence artificielle 
            pour extraire, analyser et traiter automatiquement les commandes reçues par email.
          </p>
          <p>
            Développée avec les technologies les plus avancées (Symfony 6.4, PHP 8.3, MariaDB, Redis), 
            DMS s'intègre parfaitement dans votre écosystème existant pour optimiser vos processus métier.
          </p>
        </div>
      </section>

      <!-- Fonctionnalités -->
      <section class="info-section">
        <div class="section-header">
          <i class="fas fa-cogs"></i>
          <h2>Fonctionnalités principales</h2>
        </div>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-robot" style="color: #667eea;"></i>
            </div>
            <h3>Intelligence Artificielle</h3>
            <p>Extraction automatique des données de commande avec une précision élevée grâce à l'IA.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-envelope" style="color: #48bb78;"></i>
            </div>
            <h3>Multi-comptes Email</h3>
            <p>Support IMAP, Gmail OAuth2 et Microsoft Graph pour tous vos comptes email.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-exclamation-triangle" style="color: #ed8936;"></i>
            </div>
            <h3>Détection d'Anomalies</h3>
            <p>Identification automatique des incohérences et validation intelligente.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-sync" style="color: #9f7aea;"></i>
            </div>
            <h3>Intégrations ERP</h3>
            <p>Connexions SAP, Oracle et autres systèmes pour une synchronisation complète.</p>
          </div>
        </div>
      </section>

      <!-- Technologies -->
      <section class="info-section">
        <div class="section-header">
          <i class="fas fa-code"></i>
          <h2>Technologies utilisées</h2>
        </div>
        <div class="tech-grid">
          <div class="tech-category">
            <h3>Backend</h3>
            <div class="tech-list">
              <div class="tech-item">
                <i class="fab fa-php"></i>
                <span>PHP 8.3</span>
              </div>
              <div class="tech-item">
                <i class="fas fa-server"></i>
                <span>Symfony 6.4</span>
              </div>
              <div class="tech-item">
                <i class="fas fa-database"></i>
                <span>MariaDB 11.3</span>
              </div>
              <div class="tech-item">
                <i class="fas fa-memory"></i>
                <span>Redis 7</span>
              </div>
            </div>
          </div>
          <div class="tech-category">
            <h3>Frontend</h3>
            <div class="tech-list">
              <div class="tech-item">
                <i class="fab fa-vuejs"></i>
                <span>Vue.js 3</span>
              </div>
              <div class="tech-item">
                <i class="fab fa-js"></i>
                <span>JavaScript ES6+</span>
              </div>
              <div class="tech-item">
                <i class="fab fa-css3-alt"></i>
                <span>CSS3</span>
              </div>
              <div class="tech-item">
                <i class="fas fa-mobile-alt"></i>
                <span>Responsive Design</span>
              </div>
            </div>
          </div>
          <div class="tech-category">
            <h3>Infrastructure</h3>
            <div class="tech-list">
              <div class="tech-item">
                <i class="fab fa-docker"></i>
                <span>Docker</span>
              </div>
              <div class="tech-item">
                <i class="fas fa-server"></i>
                <span>Nginx</span>
              </div>
              <div class="tech-item">
                <i class="fas fa-brain"></i>
                <span>Ollama AI</span>
              </div>
              <div class="tech-item">
                <i class="fas fa-cloud"></i>
                <span>OpenAI API</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Équipe -->
      <section class="info-section">
        <div class="section-header">
          <i class="fas fa-users"></i>
          <h2>Équipe de développement</h2>
        </div>
        <div class="team-grid">
          <div class="team-member">
            <div class="member-avatar">
              <i class="fas fa-user"></i>
            </div>
            <div class="member-info">
              <h3>Équipe DMS</h3>
              <p>Développement & Architecture</p>
              <div class="member-skills">
                <span class="skill-tag">Symfony</span>
                <span class="skill-tag">Vue.js</span>
                <span class="skill-tag">IA</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Contact -->
      <section class="info-section">
        <div class="section-header">
          <i class="fas fa-envelope"></i>
          <h2>Contact & Support</h2>
        </div>
        <div class="contact-grid">
          <div class="contact-card">
            <div class="contact-icon">
              <i class="fas fa-life-ring"></i>
            </div>
            <h3>Support technique</h3>
            <p>support@emailauto.com</p>
            <p>Disponible 24h/24, 7j/7</p>
          </div>
          <div class="contact-card">
            <div class="contact-icon">
              <i class="fas fa-book"></i>
            </div>
            <h3>Documentation</h3>
            <p>Guides d'utilisation et API</p>
            <a href="#" class="contact-link">Accéder à la documentation</a>
          </div>
          <div class="contact-card">
            <div class="contact-icon">
              <i class="fas fa-bug"></i>
            </div>
            <h3>Signaler un bug</h3>
            <p>Aidez-nous à améliorer DMS</p>
            <a href="#" class="contact-link">Signaler un problème</a>
          </div>
        </div>
      </section>

      <!-- Informations système -->
      <section class="info-section">
        <div class="section-header">
          <i class="fas fa-info"></i>
          <h2>Informations système</h2>
        </div>
        <div class="system-info">
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Version de l'application</span>
              <span class="info-value">1.0.0</span>
            </div>
            <div class="info-item">
              <span class="info-label">Version PHP</span>
              <span class="info-value">8.3</span>
            </div>
            <div class="info-item">
              <span class="info-label">Framework</span>
              <span class="info-value">Symfony 6.4</span>
            </div>
            <div class="info-item">
              <span class="info-label">Base de données</span>
              <span class="info-value">MariaDB 11.3</span>
            </div>
            <div class="info-item">
              <span class="info-label">Dernière mise à jour</span>
              <span class="info-value">{{ new Date().toLocaleDateString('fr-FR') }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Environnement</span>
              <span class="info-value">Production</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
.about {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.about-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 3rem 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.app-logo {
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 15px;
}

.app-logo .logo-image {
  width: 150px;
  height: auto;
  object-fit: contain;
  border-radius: 10px;
}

.app-info h1 {
  font-size: 3rem;
  font-weight: 700;
  color: white;
  margin: 0 0 0.5rem 0;
}

.app-tagline {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 1rem 0;
  max-width: 600px;
}

.version-info {
  display: flex;
  gap: 1rem;
}

.version-badge,
.build-info {
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.about-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 2rem;
}

.info-section {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(102, 126, 234, 0.2);
}

.section-header i {
  font-size: 1.5rem;
  color: #667eea;
  margin-right: 1rem;
}

.section-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.section-content p {
  color: #4a5568;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.feature-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 1.5rem;
}

.feature-card h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 0.5rem 0;
}

.feature-card p {
  color: #718096;
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
}

.tech-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.tech-category {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.tech-category h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.tech-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.tech-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #4a5568;
  font-size: 0.875rem;
}

.tech-item i {
  width: 20px;
  color: #667eea;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.team-member {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.member-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
}

.member-info h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 0.25rem 0;
}

.member-info p {
  color: #718096;
  font-size: 0.875rem;
  margin: 0 0 0.5rem 0;
}

.member-skills {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.skill-tag {
  padding: 0.25rem 0.5rem;
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.contact-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.contact-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 1.25rem;
  color: #667eea;
}

.contact-card h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 0.5rem 0;
}

.contact-card p {
  color: #718096;
  font-size: 0.875rem;
  margin: 0 0 0.5rem 0;
}

.contact-link {
  color: #667eea;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
}

.contact-link:hover {
  text-decoration: underline;
}

.system-info {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f7fafc;
  border-radius: 8px;
}

.info-label {
  font-weight: 500;
  color: #4a5568;
}

.info-value {
  font-weight: 600;
  color: #2d3748;
}

@media (max-width: 768px) {
  .about-header {
    padding: 2rem 1rem;
  }
  
  .logo-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .app-info h1 {
    font-size: 2rem;
  }
  
  .about-content {
    padding: 2rem 1rem;
  }
  
  .info-section {
    padding: 1.5rem;
  }
  
  .version-info {
    justify-content: center;
  }
  
  .features-grid,
  .tech-grid,
  .team-grid,
  .contact-grid {
    grid-template-columns: 1fr;
  }
}

.info-grid {
  grid-template-columns: repeat(auto-fit, minmax(min(250px, 100%), 1fr));
}

.app-logo {
  flex-shrink: 0;
  overflow: hidden;
}

.app-logo .logo-image {
  max-width: 100%;
}

.app-info,
.member-info,
.info-item > * {
  min-width: 0;
}

.contact-card p,
.info-value {
  overflow-wrap: anywhere;
}

.info-item {
  gap: 0.75rem;
}

.info-value {
  text-align: right;
}

@media (max-width: 767.98px) {
  .about {
    min-height: 0;
    border-radius: inherit;
  }

  .about-header {
    padding: 1.5rem 1rem;
  }

  .app-logo {
    width: 80px;
    height: 80px;
    padding: 12px;
  }

  .app-tagline {
    font-size: 1rem;
  }

  .version-info {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .about-content {
    padding: 1.25rem 0.75rem;
  }

  .info-section {
    padding: 1.25rem 1rem;
    border-radius: 16px;
    margin-bottom: 1.25rem;
  }

  .section-header {
    margin-bottom: 1rem;
  }

  .section-header i {
    font-size: 1.25rem;
    margin-right: 0.75rem;
  }

  .section-header h2 {
    font-size: 1.25rem;
  }

  .features-grid,
  .contact-grid {
    gap: 1rem;
  }

  .tech-grid {
    gap: 1rem;
  }

  .feature-card,
  .tech-category,
  .team-member,
  .contact-card {
    padding: 1.25rem 1rem;
  }

  .member-avatar {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    font-size: 1.25rem;
  }

  .system-info {
    padding: 0.75rem;
  }
}

@media (max-width: 575.98px) {
  .info-item {
    flex-wrap: wrap;
  }
}
</style>